export default "__VITE_ASSET__1f5A05Fc__"